// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hQ","header":"hR","title":"hS","subHeader":"hT"};